import { AxiosPromise } from "axios";
import {
  LocationDto,
  MemberDto,
  TeamsResourceApi,
} from "../generated/account-client";
import { accountApiConfig, ops } from "./config";

const api = new TeamsResourceApi(accountApiConfig);

const TeamsApi = {
  getUsers(teamId: string): AxiosPromise<MemberDto[]> {
    return api.getTeamUsers(teamId, ops());
  },
  getUsersWithOwner(teamId: string): AxiosPromise<MemberDto[]> {
    return api.getTeamUsersWithOwner(teamId, ops());
  },
  getTeamOwner(teamId: string): AxiosPromise<MemberDto> {
    return api.getTeamOwner(teamId, ops());
  },
  getLocations(teamId: string): AxiosPromise<LocationDto[]> {
    return api.getTeamLocations(teamId, ops());
  },
  getTeamLocationsWithLogos(teamId: string): AxiosPromise<LocationDto[]> {
    return api.getTeamLocationsWithLogos(teamId, ops());
  },
  createLocation(teamId: string, locations: LocationDto[]): AxiosPromise<void> {
    return api.createTeamLocation(teamId, locations, ops());
  },
  validateLocation(
    teamId: string,
    locations: LocationDto[]
  ): AxiosPromise<void> {
    return api.validateTeamLocation(teamId, locations, ops());
  },
};

export default TeamsApi;
